import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';
import {
  CreateUpdateEmailAddressDto,
  GetClientDto,
  GetEmailAddressDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  convert,
  newEmailAddress,
  validate,
} from '../../../common/pokCore/contexts/EmailAddressContext';
import { responseErrors } from '../../../common/pokCore/validation/responseErrors';

import { EmailAddressEditor } from './EmailAddressEditor';

interface AddEditEmailButtonProps {
  emailAddress?: GetEmailAddressDto;
  clientId?: string;
  client?: GetClientDto;
  refresh: boolean;
  setRefresh: (refresh: boolean) => void;
}

export const AddEditEmailButton: React.FC<AddEditEmailButtonProps> = props => {
  const { t, tk } = useTranslation('clientLng');
  const [show, setShow] = useState<boolean>(false);
  const [emailAddress, setEmailAddress] = useState<
    GetEmailAddressDto | undefined
  >(props.emailAddress);

  useEffect(() => {
    setEmailAddress(props.emailAddress);
  }, [props.emailAddress]);

  const pok = usePokCore();

  const handleAdd = () => {
    setShow(true);
    // setEmailAddress(undefined);
  };

  const handleClose = () => {
    setShow(false);
  };

  const addEditEmailAddress = async (
    emailAddressCU: CreateUpdateEmailAddressDto,
    id?: string,
  ) => {
    const status = await validate(emailAddressCU);
    if (status.valid) {
      try {
        if (id) {
          await pok.emailAddresses.update(id, emailAddressCU);
        } else {
          await pok.emailAddresses.create(emailAddressCU);
        }
        setShow(false);
        props.setRefresh(!props.refresh);
        return {
          saved: true,
          errors: [],
        };
      } catch (response) {
        return {
          saved: false,
          errors: await responseErrors(response as ResponseError),
        };
      }
    } else {
      return {
        saved: false,
        errors: status.errors,
      };
    }
  };

  return (
    <>
      {!props.emailAddress?.id && (
        <OverlayTrigger overlay={<Tooltip>{t(tk.emailAddress.new)}</Tooltip>}>
          <Button
            onClick={e => {
              e.stopPropagation();
              handleAdd();
            }}
            variant="btn-info"
            className="ps-2 pe-0"
          >
            <Icon.Mailbox2Flag className="icon-green" size={16} />
          </Button>
        </OverlayTrigger>
      )}
      {props.emailAddress?.id && (
        <OverlayTrigger overlay={<Tooltip>{t(tk.emailAddress.edit)}</Tooltip>}>
          <Button
            onClick={e => {
              e.stopPropagation();
              handleAdd();
            }}
            variant="btn-info"
            className="ps-2 pe-0"
          >
            <Icon.Pencil className="icon-green" size={16} />
          </Button>
        </OverlayTrigger>
      )}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={e => e.stopPropagation()}>
        <EmailAddressEditor
          id={emailAddress?.id}
          emailAddress={
            emailAddress
              ? convert(emailAddress)
              : newEmailAddress(props.clientId)
          }
          onCompleted={addEditEmailAddress}
          show={show}
          handleClose={handleClose}
          client={props.client}
        />
      </div>
    </>
  );
};
